import { getImageSizeFromFile } from '@cp/utils/browser/image';
import { CLIENT_PHOTO_FILE_SIZE_MAX, CLIENT_PHOTO_MIN_HEIGHT, CLIENT_PHOTO_MIN_WIDTH } from '@common/const/client/photo';

export const validateClientPhoto = async (file: File) => {
  const imageSize = await getImageSizeFromFile(file);

  if (file.size > CLIENT_PHOTO_FILE_SIZE_MAX) {
    throw new Error(`Размер файла не должен превышать ${CLIENT_PHOTO_FILE_SIZE_MAX} Мб`);
  }

  if (imageSize.width < CLIENT_PHOTO_MIN_WIDTH) {
    throw new Error(`Ширина изображения должна быть не меньше ${CLIENT_PHOTO_MIN_WIDTH} пикселей`);
  }

  if (imageSize.height < CLIENT_PHOTO_MIN_HEIGHT) {
    throw new Error(`Высота изображения должна быть не меньше ${CLIENT_PHOTO_MIN_HEIGHT} пикселей`);
  }
};
